module.exports = __webpack_public_path__ + "static/media/bart.7aa0f2f2.png";